import React from 'react';
import Switch from '@mui/material/Switch';
import { useTranslation } from 'react-i18next';
import { trackEventBudget, TRACKABLE_EVENTS } from 'helpers/trackerHelpers';
import { BudgetProposalT } from 'routes/BudgetModule/config/types';
import { FilterConfigT } from './steps/ThirdDuplicateArgumentsStep';
import { BudgetBys } from 'business/constants';
import { getResourceTranslation } from '../DuplicateSettings/helpers';

type Props = {
    filterValues: FilterConfigT;
    budgetProposals: BudgetProposalT[];
    resource: string;
    setFilterValues: DispatchState<FilterConfigT>;
    by: BudgetBys;
};

export default function ArgumentDuplicationSwitches({
    filterValues,
    setFilterValues,
    budgetProposals,
    resource,
    by,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    const trackEvent = (item: 'resource' | 'section' | 'budget') =>
        trackEventBudget(
            TRACKABLE_EVENTS.budget.settings.duplicateArgumentaire[item],
            {
                budgetProposals: budgetProposals.map((b) => b.name),
                resource: resource,
            },
        );

    return (
        <>
            {['resource' as const, 'section' as const, 'budget' as const].map(
                (item) => (
                    <div key={item}>
                        <Switch
                            checked={filterValues[item]}
                            onChange={() => {
                                setFilterValues({
                                    ...filterValues,
                                    [item]: !filterValues[item],
                                });
                                trackEvent(item);
                            }}
                        />
                        {t(`duplication.${item}Filter`, {
                            resource: getResourceTranslation(by),
                        })}
                    </div>
                ),
            )}
        </>
    );
}
